module.exports = __webpack_public_path__ + "img/bra.15a36bbc.svg";